/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.BatchFileTransactionsResponse,
  (requestParams: vp.BatchFileTransactionsRequest) => void,
  () => void,
];

function useFetchBatchFileTransactions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.BatchFileTransactionsRequest>();
  const [response, setResponse] = useState<vp.BatchFileTransactionsResponse>({
    ErrorMessage: '',
    Success: false,
    Transactions: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.BatchFileTransactionsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchBatchFileTransactions(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.BatchFileTransactionsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Transactions: {},
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchBatchFileTransactions);
